import Api from '@/api';
import Vuex from 'vuex';
import config from '@/config';
import createLogger from 'vuex/dist/logger';

export const createStore = () => {
  return new Vuex.Store({
    plugins: [
      config.env === 'production' ? undefined : createLogger(),
    ].filter(Boolean),
    state: {
      loadingFutures: false,
      futureData: {},
    },
    mutations: {
      SET_LOADING_FUTURES(state, loading) {
        state.loadingFutures = loading;
      },
      SET_FUTURE_DATA(state, data) {
        state.futureData = data;
      },
    },
    actions: {
      async loadFutures({ commit, state, dispatch}) {
        if (state.loadingFutures) {
          return;
        }

        commit('SET_LOADING_FUTURES', true);
        const { data } = await Api.get('futures').get();
        commit('SET_FUTURE_DATA', data);
        commit('SET_LOADING_FUTURES', false);
      },
    },
    getters: {
      loadingFutures(state) {
        return state.loadingFutures;
      },
      futureData(state) {
        return state.futureData;
      },
    },
  });
};
